export const convertRoleName = (role: EEmployeeRole | string): string => {
	const rolesMap: { [key in EEmployeeRole]: string } = {
		[EEmployeeRole.SUPER_ADMIN]: 'Super Admin',
		[EEmployeeRole.ADMIN]: 'Admin',
		[EEmployeeRole.MES_SUPER_ADMIN]: 'Super Admin',
		[EEmployeeRole.MES_ADMIN]: 'Admin',
		[EEmployeeRole.PRODUCTION_MANAGER]: 'Manager Produkcji',
		[EEmployeeRole.TECHNOLOGIST]: 'Technolog',
		[EEmployeeRole.PRODUCTION_COST_SPECIALIST]: 'Specjalista ds. rozliczeń technologicznych',
		[EEmployeeRole.WAREHOUSE_OPERATOR]: 'Magazynier',
		[EEmployeeRole.INTERNAL_LOGISTICS]: 'Logistyk wewnętrzny',
		[EEmployeeRole.CONTRACT_PURCHASING_SPECIALIST]: 'Zakupowiec kontraktów',
		[EEmployeeRole.DELIVERY_LOGISTICS]: 'Logistyk dostaw',
		[EEmployeeRole.TABLET_USER]: 'Tablet',
		[EEmployeeRole.MES_INTEGRATION]: 'Integracja',
		[EEmployeeRole.CRM_INTEGRATION]: 'Integracja CRM',
		[EEmployeeRole.SCM_INTEGRATION]: 'Integracja SCM',
	}

	return rolesMap[role] ?? role
}
